const account_center = {
    not_enabled: 'Trung tâm tài khoản chưa được bật.',
    field_not_editable: 'Trường này không thể chỉnh sửa.',
    field_not_enabled: 'Trường này chưa được bật.',
};
export default Object.freeze(account_center);
